import { RecordField } from "@/components/admin/record-field"
import { UserRelatedShow } from "@/modules/users/components/Show"
const ContractShow: React.FC = function () {
  return (
    <UserRelatedShow>
      <RecordField source="id" />
    </UserRelatedShow>
  )
}

export default ContractShow
